(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/to-array-or-null.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/to-array-or-null.js');
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var toArrayOrNull = function toArrayOrNull(input) {
  if (!input || _typeof(input) !== 'object') {
    return null;
  }
  var result = [];
  if (_typeof(input) === 'object' && input !== null) {
    if (Array.isArray(input)) {
      result.push.apply(result, _toConsumableArray(input));
    } else {
      for (var key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
          result.push(input[key]);
        }
      }
    }
  }
  return result;
};
if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  module.exports = {
    toArrayOrNull: toArrayOrNull
  };
} else {
  svs.content.image_v2.helpers.toArrayOrNull = toArrayOrNull;
}

 })(window);